import { httpClient } from '@/Common/api/http_client';

/**
 *
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getAllSuppliers() {
  return httpClient.get('/merchant/suppliers');
}

/**
 *
 * @param supplierId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getSupplier(supplierId) {
  return httpClient.get(`/merchant/suppliers/${supplierId}`);
}

/**
 *
 * @param supplierId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function deleteSupplier(supplierId) {
  return httpClient.delete(`/merchant/suppliers/${supplierId}`);
}

/**
 *
 * @param supplierId
 * @param supplier
 * @returns {Promise<AxiosResponse<T>>}
 */
export function updateSupplier(supplierId, supplier) {
  return httpClient.put(`/merchant/suppliers/${supplierId}`, supplier);
}

/**
 *
 * @param supplier
 * @returns {Promise<AxiosResponse<T>>}
 */
export function newSupplier(supplier) {
  return httpClient.post('/merchant/suppliers', supplier);
}

// Merchant Specific APIs ends
// =========================================
